import { ReactElement, useState, useEffect } from "react";
import { Layout, Statistic, Row, Col, Card, Table, BackTop } from "antd";
import { UsergroupAddOutlined } from "@ant-design/icons";
import firebase from "firebase/app";
import "firebase/firestore";
import moment from "moment";
import { ContentHeader } from "../../components/GlobalStyles";

const { Content } = Layout;
const statisticsValueStyle = {
  fontWeight: 700,
  fontFamily: "Raleway",
  display: "flex",
  justifyContent: "center",
  fontSize: 40,
  marginTop: 10
}

const recentBookingTableHeader = [
  {
    title: "#",
    key: "bookId",
    dataIndex: "bookId"
  },
  {
    title: "Club",
    key: "club",
    dataIndex: "club"
  },
  {
    title: "Branch",
    key: "branch",
    dataIndex: "branch"
  },
  {
    title: "Court",
    key: "court",
    dataIndex: "court"
  },
  {
    title: "User Name",
    key: "userName",
    dataIndex: "userName"
  },
  {
    title: "Time",
    key: "time",
    dataIndex: "time"
  },
  {
    title: "Date",
    key: "date",
    dataIndex: "date"
  },
  {
    title: "Price",
    key: "price",
    dataIndex: "price"
  },
  {
    title: "Payment Method",
    key: "paymentMethod",
    dataIndex: "paymentMethod"
  }
]

export function Dashboard(): ReactElement {
  const firestore = firebase.firestore();
  const [loading, setLoading] = useState(false);
  const [totalUser, setTotalUser] = useState(0);
  const [todayNewUser, setTodayNewUser] = useState(0);
  const [weekNewUser, setWeekNewUser] = useState(0);
  const [monthNewUser, setMonthNewUser] = useState(0);
  const [todayBookings, setTodayBookings] = useState(0);
  const [weekBookings, setWeekBookings] = useState(0);
  const [monthBookings, setMonthBookings] = useState(0);
  const [recentBookings, setRecentBookings] = useState<any[]>([]);

  // Get user statistics
  useEffect(() => {
    setLoading(true);
    const today = moment();
    const weekNumber = today.format('w');
    const year = today.format('YYYY');
    const month = today.format("M");
    setTodayNewUser(0);
    setWeekNewUser(0);
    setTotalUser(0);
    setMonthNewUser(0);
    firestore.collection("users").where("role", "==", "regular").get()
      .then(querySnapshots => {
        querySnapshots.docs.map(doc => {
          const data = doc.data();
          setTotalUser(origin => origin + 1);
          const createdAt = moment(data.creationTime);
          if (createdAt.format("YYYY-MM-DD") === today.format("YYYY-MM-DD")) setTodayNewUser(origin => origin + 1);
          // this week
          if (createdAt.format("YYYY") === year && createdAt.format('w') === weekNumber) setWeekNewUser(origin => origin + 1);
          // this month
          if (createdAt.format("YYYY") === year && createdAt.format("M") === month) setMonthNewUser(origin => origin + 1);
          return data;
        })
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        console.error(e);
      })
  }, [])

  // Get booking statistics
  useEffect(() => {
    const thisMonth = moment().format("YYYY-MM-01");
    const today = moment();
    const weekNumber = today.format("w");
    const year = today.format("YYYY");
    setMonthBookings(0);
    setWeekBookings(0);
    setTodayBookings(0);
    // alert(thisMonth);
    firestore.collection("bookings").where("date", ">=", thisMonth).get()
      .then(querySnapshots => {
        querySnapshots.docs.map(doc => {
          const data = doc.data();
          const bookingDate = moment(`${data.date}T00:00:00`);
          if (today.format("YYYY-MM-DD") === bookingDate.format("YYYY-MM-DD")) setTodayBookings(origin => origin + 1);
          // this week 
          if (bookingDate.format("YYYY") === year && bookingDate.format("w") === weekNumber) setWeekBookings(origin => origin + 1);
          // month
          setMonthBookings(origin => origin + 1);
          return data;
        })
      })
  }, [])

  useEffect(() => {
    firestore.collection("bookings").limit(10).orderBy("date")
      .onSnapshot(snapshot => {
        snapshot.docChanges().forEach(async (change) => {
          if (change.type === "added") {
            const bookData = change.doc.data();
            const clubSnapshot = await firebase.firestore().collection("clubs").doc(bookData.club).get();
            const branchSnapshot = await firebase.firestore().collection("branches").doc(bookData.branchId).get();
            const courtSnapshot = await firebase.firestore().collection("courts").doc(bookData.courtId).get();
            let userName = "";
            if (bookData.userId) {
              const userSnapshot = await firebase.firestore().collection("users").doc(bookData.userId).get();
              userName = userSnapshot.data()?.fullName;
            } else {
              userName = bookData.user.fullName;
            }
            const book = {
              bookId: bookData.bookingId,
              club: clubSnapshot.data()?.name,
              branch: branchSnapshot.data()?.location,
              court: courtSnapshot.data()?.name,
              userName,
              time: moment(`2020-01-01T${bookData.start}`).format("h:mm A"),
              date: bookData.date,
              period: bookData.period,
              price: bookData.price + bookData.currency,
              paymentMethod: bookData.paymentMethod === "online" ? "Online" : "Pay over count"
            }
            setRecentBookings(origin => [book, ...origin]);
          }
        });
      })
  }, [])

  return (
    <Content>
      <BackTop />
      <ContentHeader>Dashboard</ContentHeader>
      <Row gutter={16}>
        <Col span={6}>
          <Card className="dashboard-statistics-card">
            <Statistic value={totalUser} title="Total Users" loading={loading} valueStyle={statisticsValueStyle} />
          </Card>
        </Col>
        <Col span={6}>
          <Card className="dashboard-statistics-card">
            <Statistic value={todayNewUser} title="New Users Today" loading={loading} valueStyle={statisticsValueStyle} />
          </Card>
        </Col>
        <Col span={6}>
          <Card className="dashboard-statistics-card">
            <Statistic value={weekNewUser} title="New Users this week" loading={loading} valueStyle={statisticsValueStyle} />
          </Card>
        </Col>
        <Col span={6}>
          <Card className="dashboard-statistics-card">
            <Statistic value={monthNewUser} title="New Users this month" loading={loading} valueStyle={statisticsValueStyle} />
          </Card>
        </Col>
      </Row>
      <Row gutter={16} style={{ marginTop: 20 }}>
        <Col span={8}>
          <Card className="dashboard-statistics-card">
            <Statistic value={todayBookings} title="Bookings Today" valueStyle={statisticsValueStyle} />
          </Card>
        </Col>
        <Col span={8}>
          <Card className="dashboard-statistics-card">
            <Statistic value={weekBookings} title="Bookings this week" valueStyle={statisticsValueStyle} />
          </Card>
        </Col>
        <Col span={8}>
          <Card className="dashboard-statistics-card">
            <Statistic value={monthBookings} title="Bookings this month" valueStyle={statisticsValueStyle} />
          </Card>
        </Col>
      </Row>
      <Row gutter={16} style={{ marginTop: 20 }}>
        <Col span={24}>
          <Card className="dashboard-statistics-card" title="Recent Bookings">
            <Table dataSource={recentBookings} columns={recentBookingTableHeader} pagination={false} rowKey={item => item.bookId} />
          </Card>
        </Col>
      </Row>
    </Content>
  );
}
